<template lang="pug">
  #sobre
    bloco-texto.-rightalign(imagem="static/imagem_padrao.jpg", :rota="'apresentacao'")
      template(slot="titulo") O que é a PROAD?
      template(slot="texto") A PROAD é o órgão responsável pela supervisão e coordenação das áreas de contabilidade, finanças, material, patrimônio, segurança, transportes e serviços gerais da UFRN.
    bloco-texto.-leftalign(imagem="static/imagem_padrao.jpg", :rota="'acoes'")
      template(slot="titulo") Conheça nossas ações
      template(slot="texto") Dentre às diversas ações que a PROAD está executando, destacamos a contribuição para a elaboração do PLS - Plano de Gestão de Logística Sustentável da UFRN.
</template>

<style lang="scss">
  #sobre {

  }
</style>

<script>
import Bloco from 'COMPONENTS/Bloco'
import BlocoTexto from 'COMPONENTS/BlocoTexto'
import Titulo from 'COMPONENTS/ElementTitle'
export default {
  name: 'sobre',
  components: {
    Bloco,
    BlocoTexto,
    Titulo
  }
}
</script>



// WEBPACK FOOTER //
// Sobre.vue?494d1dd9